import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { PageBody, PageHeader, EmptyState } from "@/components/Page";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

const ALL = "__all__";

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [actions, setActions] = useState([]);
  const [action, setAction] = useState(ALL);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const load = async () => {
    const params = {};
    if (action !== ALL) params.action = action;
    if (start) params.start = new Date(start).toISOString();
    if (end) params.end = new Date(end + "T23:59:59").toISOString();
    const { data } = await api.get("/admin/audit", { params });
    setRows(data.rows); setActions(data.actions);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [action, start, end]);

  return (
    <PageBody>
      <PageHeader eyebrow="Admin" title="Audit log" subtitle="Every material action - generate, approve, send, import, invite, remove, plan change, suppression add. Owners and admins only." />

      <div className="flex flex-wrap gap-2 mb-5">
        <Select value={action} onValueChange={setAction}>
          <SelectTrigger className="w-[200px]" data-testid="audit-filter-action"><SelectValue placeholder="Action" /></SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>All actions</SelectItem>
            {actions.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}
          </SelectContent>
        </Select>
        <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="w-[160px]" data-testid="audit-filter-start" />
        <Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="w-[160px]" data-testid="audit-filter-end" />
      </div>

      {rows.length === 0 ? (
        <EmptyState icon={ScrollText} title="No audit entries" body="Actions taken in this organization will appear here." />
      ) : (
        <div className="rounded-xl border border-border/70 overflow-hidden" data-testid="audit-table">
          <table className="w-full text-sm">
            <thead className="bg-accent/40 text-muted-foreground">
              <tr>
                <th className="text-left font-medium p-3">Time</th>
                <th className="text-left font-medium p-3">Actor</th>
                <th className="text-left font-medium p-3">Action</th>
                <th className="text-left font-medium p-3">Object</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id || `${r.at}-${i}`} className="border-t border-border/50" data-testid="audit-row">
                  <td className="p-3 text-muted-foreground font-mono text-xs whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
                  <td className="p-3">{r.user_name || "-"}</td>
                  <td className="p-3"><span className="text-[10px] font-mono uppercase px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-500">{r.action}</span></td>
                  <td className="p-3 text-muted-foreground font-mono text-xs truncate max-w-[280px]">{r.target}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PageBody>
  );
}
